@if (isUserLoggedIn) {
  <div [ngClass]="{ wrapperPadding: !isEyefinityApp }">
    @if (!isEyefinityApp) {
      <div [ngClass]="{ surround: !isEyefinityApp }">
        <header class="header clearfix">
          <div class="row">
            <div class="col">
              <div class="logo-pad">
                @if (routedFromEpm) {
                  <img
                    src="https://www.eyefinity.com/dam/jcr:3d947a4b-af06-497f-8198-8edfad08f297/EF-encompass_logo_RGB.svg"
                    alt="Eyefinity Encompass"
                    title="Eyefinity Encompass"
                  />
                }
              </div>
            </div>
            @if (!isLoggingOut && !isOnErrorPage && !isEyefinityApp) {
              <div class="col">
                <div class="pull-right">
                  <div class="row">
                    <div class="col">
                      <span class="loggedInTitle pt-2">Logged in as: </span>
                      <button
                        (click)="showPanel = !showPanel"
                        class="btn-link btn btn-lg dropdown-toggle pull-right"
                        id="dropdownLogoutMenu"
                        type="button"
                      >
                        {{ accessToken.principal }}
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div id="logoutPanel">
                        @if (showPanel) {
                          <div
                            class="card innerLogoutPanel eyefinityBlueBorder mb-3"
                          >
                            <div class="row">
                              <div class="col pt-3 pb-3">
                                Company Id: {{ accessToken.companyId }}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col pt-3 pb-3">
                                EFAN: {{ accessToken.efan }}
                              </div>
                            </div>
                            @if (
                              accessToken.application === APPLICATION_NAMES.pe
                            ) {
                              <div class="row">
                                <div class="col pt-2 pb-2">
                                  <a
                                    (click)="showPanel = false"
                                    routerLink="/pe/support"
                                    >Switch Practices</a
                                  >
                                </div>
                              </div>
                            }
                            <div class="row">
                              <div class="col pt-2">
                                <button
                                  (click)="logout()"
                                  class="ewebButtonXtraLarge btn btn-lg btn-primary"
                                  id="signOutBtn"
                                >
                                  Sign Out
                                </button>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </header>
        @if (isLoggingOut) {
          <iframe
            [src]="logoutUrl"
            (load)="performLogout()"
            height="0"
            id="logoutIframe"
            width="0"
          ></iframe>
        }
      </div>
    }
    <meta content="{{ version }}" itemprop="PE-CONN version" />
    @if (!isLoggingOut && (isUserLoggedIn || isOnErrorPage)) {
      <router-outlet class="w-100"></router-outlet>
    }
    @if (isLoggingOut) {
      <div id="logoutDiv">
        <div class="row">
          <div class="col d-flex justify-content-center mt-5">
            {{ logoutText }}
          </div>
        </div>
        <div class="row p-4">
          <div class="col d-flex justify-content-center">
            @if (!hideLoginButton) {
              <button
                (click)="login()"
                class="btn ewebButtonXtraLarge btn-primary"
              >
                Login
              </button>
            }
          </div>
        </div>
      </div>
    }
    @if (!hideFooter) {
      <conn-version-footer [isEyefinityApp]="isEyefinityApp" />
    }
  </div>
}
